import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  FETCH_TASK_PROFILES,
  fetchTaskProfilesSuccess,
  fetchTaskProfilesFailed,
  fetchingTaskProfiles,
  FETCH_TASK_PROFILE,
  fetchTaskProfileSuccess,
  fetchTaskProfileFailed,
  fetchingTaskProfile,
} from '../actions/taskprofiles';

import { toArray, id } from '../utils/helper';
import { saveTaskProfileRoutine, removeTaskProfileRoutine } from '../routines';
import { fetchCol, fetchDoc, getTenantPath, updateSaga, setSaga } from './helper';

function fetchTaskProfiles() {
  return fetchCol(getTenantPath('taskprofiles'))
    .then((profiles) => toArray(profiles).filter((profile) => !profile.deleted));
}

function* fetchTaskProfilesSaga() {
  try {
    yield put(fetchingTaskProfiles());
    const taskProfiles = yield call(fetchTaskProfiles);
    yield put(fetchTaskProfilesSuccess(taskProfiles));
  } catch (err) {
    console.error('error', err);
    yield put(fetchTaskProfilesFailed(err));
  }
}

function* watchFetchTaskProfilesSaga() {
  yield takeLatest(FETCH_TASK_PROFILES, fetchTaskProfilesSaga);
}

function fetchTaskProfile(id) {
  const path = `taskprofiles/${id}`;
  return fetchDoc(path);
}

function* fetchTaskProfileSaga(action) {
  try {
    yield put(fetchingTaskProfile());
    const taskProfile = yield call(fetchTaskProfile, action.taskProfileId);
    yield put(fetchTaskProfileSuccess(taskProfile));
  } catch (err) {
    console.error('Failed to load task profile', err);
    yield put(fetchTaskProfileFailed(err));
  }
}

function* watchFetchTaskProfileSaga() {
  yield takeLatest(FETCH_TASK_PROFILE, fetchTaskProfileSaga);
}

function* watchSaveTaskProfileSaga() {
  yield takeEvery(saveTaskProfileRoutine.TRIGGER, setSaga(saveTaskProfileRoutine,
    (payload) => {
      const path = getTenantPath(`taskprofiles/${payload.values.get('id') || id()}`);
      console.log('path', path);
      return path;
    },
    (payload) => {
      console.log('watchSaveTaskProfileSaga', payload.values.toJS());
      const data = _.assign({},_.pick(payload.values.toJS(), ['name', 'description', 'itemTypes']));
      console.log('data', data);
      return data;
    },
    false,
  ));
}

function* watchRemoveTaskProfileSaga() {
  yield takeEvery(removeTaskProfileRoutine.TRIGGER, updateSaga(removeTaskProfileRoutine,
    (taskProfile) => getTenantPath(`taskprofiles/${taskProfile.id}`),
    () => ({
      deleted: {
        at: new Date().toISOString(),
      },
    }),
  ));
}

export {
  watchFetchTaskProfilesSaga,
  watchFetchTaskProfileSaga,
  watchSaveTaskProfileSaga,
  watchRemoveTaskProfileSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/taskprofiles.js